<template>
  <v-container fluid tag="section">
    <base-material-table
      outlined
      :item="item"
      ref="table"
      @on-add='add'
    >
    </base-material-table>
    <add-view :item='addModal' @on-load-data='loadData'></add-view>
  </v-container>
</template>

<script>
  import { selectData2, selectMonthData } from '@/utils/tool.js'
  import AddView from './components/Add'

  export default {
    name: 'SettingReward',
    components: {
      AddView
    },
    data() {
      return {
        loading: false,
        addModal: { show: false, data: {} },
        item: {
          path: '/setting/reward/info/list',
          topButtons: [
            { event: 'search', show: true },
            { event: 'add', show: this.$_has("set-target-add") }
          ],
          headers: [
            {
              text: '年份',
              align: 'center',
              divider: true,
              value: 'startTime',
              sortable: false,
              width: 120,
              formatter: (val) => this.$moment(val * 1000).format('YYYY'),
              search: {
                type: 'select',
                itemText: 'label',
                secKey: 'year',
                options: () => selectData2()
              }
            },
            {
              text: '月份',
              align: 'center',
              divider: true,
              value: 'startTime',
              sortable: false,
              width: 120,
              formatter: (val) => this.$moment(val * 1000).format('MM'),
              search: {
                type: 'select',
                itemText: 'label',
                secKey: 'month',
                options: () => selectMonthData()
              }
            },
            {
              text: '激励类型',
              align: 'center',
              divider: true,
              value: 'type',
              sortable: false,
              width: 120,
              formatter: (val) => (val === 1 ? '个人绩效' : val === 2 ? '部门绩效' : '个人收款'),
              search: {
                type: 'select',
                options: () => [
                  { text: '个人绩效', value: 1 },
                  { text: '部门绩效', value: 2 },
                  { text: '个人收款', value: 3 }
                ]
              }
            },
            {
              text: '激励内容',
              align: 'center',
              value: 'content',
              width: 220,
              sortable: false,
              divider: true,
            },
            {
              text: '开始时间',
              align: 'center',
              value: 'startTime',
              width: 120,
              sortable: false,
              divider: true,
              formatter: (val) => this.$moment(val * 1000).format('YYYY-MM-DD')
            },
            {
              text: '结束时间',
              align: 'center',
              value: 'endTime',
              width: 120,
              sortable: false,
              divider: true,
              formatter: (val) => this.$moment(val * 1000).format('YYYY-MM-DD')
            },
            {
              text: '创建时间',
              align: 'center',
              value: 'createTime',
              width: 120,
              sortable: false,
              formatter: (val) => this.$moment(val * 1000).format('YYYY-MM-DD')
            },
            {
              text: '操作',
              value: 'actions',
              align: 'center',
              width: 140,
              class: 'fixed-right',
              cellClass: 'fixed-right',
              sortable: false,
              actions: [
                {
                  text: '删除',
                  color: 'warning',
                  icon: 'mdi-delete',
                  onClick: (row, btn) => this.$refs.table.doDelete(row, btn),
                  disable: () => !this.$_has('set-reward-add')
                },
                {
                  text: '编辑',
                  color: 'warning',
                  icon: 'mdi-delete',
                  onClick: (row) => this.addModal = { show: true, data: row },
                  disable: () => !this.$_has('set-reward-add')
                }
              ]
            }
          ]
        }
      }
    },
    methods: {
      add () {
        this.addModal = { show: true }
      },
      loadData () {
        this.$refs.table.loadData()
      }
    }
  }
</script>

<style>
</style>
